import { Page } from '@/core/architecture'

import { StoreDeliveryInfoTemplate } from './template'
import { useViewModel } from './viewModel'

export const StoreDeliveryInfo: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreDeliveryInfoTemplate state={state} {...actions} />
}
